import { LoadingSkeleton } from '@trufla-technology/trumarket-react-design-system';
import './style.scss';

export const NewTeamLoading = () => {
  return (
    <div>
      {[...Array(10)].map((_, i) => (
        <LoadingSkeleton
          key={`team-loading-${i}`}
          lines={1}
          width="100%"
          isLoading={true}
        ></LoadingSkeleton>
      ))}
    </div>
  );
};
